export function getHeightBounds(
  possibleSizes: { w: number; h: number }[],
  currentWidth: number,
  expandableSpace: number
) {
  "worklet";

  const sortedHeights = possibleSizes
    .filter(({ w, h }) => currentWidth === w && h <= expandableSpace)
    .map(({ h }) => h)
    .sort();
  if (sortedHeights.length === 0) {
    return {
      min: currentWidth,
      max: currentWidth,
    };
  }
  return {
    min: sortedHeights[0],
    max: sortedHeights[sortedHeights.length - 1],
  };
}
